import React, { memo } from 'react';
import Modal from '../../../ui/Modal';
import singleton from '../../../core/singleton';

const ModalOrder = props => {
    const { getTradByKey } = singleton.getInstance();
    const productPrice = product => product.prices.find(price => (price.currency.isoCode === props.modalData.currency.iso_code));
    return <Modal onClose={() => props.setModalData(null)}>
        <div className="modal-header">
            <h5 className="modal-title">{`${(props.modalData.seat === "null") ? `Seat:${props.modalData.seat} ` : ''} (${props.modalData.first_name[0]}.${props.modalData.last_name} )`}
                <br />
                <small>Order: {props.modalData.invoice_number_short}</small>
            </h5>
            <button onClick={() => props.setModalData(null)} type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div className="modal-body max-height-260px overflow-y-auto">
            <ul className="list-group list-group-flush mb-3 ">
                {
                    props.modalData.cart.products.map((product, index) => <li key={index} className="list-group-item pl-0 pr-0">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6">
                                    <h6>{product.title} </h6>
                                    <h6>Quantity: {product.quantity}</h6>
                                    <h6>Total: {productPrice(product).realValue}{productPrice(product).currency.symbol}</h6>
                                </div>
                                <div className="col-6 text-right align-self-end">
                                    <h6>Total: {productPrice(product).realValue * product.quantity}{productPrice(product).currency.symbol}</h6>
                                </div>
                            </div>
                        </div>

                    </li>)
                }
            </ul>
            <div className="row align-items-center">
                <div className="col-12">
                    <h4 className="text-right pt-1">Total: {props.modalData.total_paid}{props.modalData.currency.symbol}</h4>
                </div>
            </div>
        </div>


        {
            (props.ordersWorkflow.transitions[props.modalData.status].length > 0) &&
            <div className="modal-footer">
                <div className="btn-group-vertical w-100">
                    {

                        props.ordersWorkflow.transitions[props.modalData.status].map((s, i) => <button
                            onClick={() => {
                                props.onStatusChange(s, props.modalData);
                            }}
                            className={`btn d-block btn-outline-primary`}
                            key={i}>{getTradByKey(`places.${s}`)}</button>)
                    }
                </div>
            </div>
        }
    </Modal>
}
export default memo(ModalOrder);